import { TextButton, Typography } from "matsuri-ui"
import { css } from "@emotion/react"
import { useNavigate, useParams } from "react-router-dom"
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew"
import dayjs from "dayjs"
import PaymentIcon from "../../components/Icon/Payment.svg"
import { useReportedApprovalRequestsByDay } from "./useReportedApprovalRequestsByDay"
import { CleaningPlaceList } from "./cleaningPlaceList/CleaningPlaceList"
import { showJpYen } from "@/utils/showJpYen"
import { formatDate } from "@/utils/dateString"
import { summarizeUnitPrice } from "@/parts/Achievement/sales/calcSalesSummary"
import { theme } from "@/theme"
import { useTranslation } from "@/hooks/useTranslation"

export const AchievementDetailPage = () => {
    const { t } = useTranslation()
    const { date } = useParams<{ date: string }>()
    const targetDate = dayjs(date)

    const targetDateString = formatDate(targetDate)

    const { reportedApprovalRequests } =
        useReportedApprovalRequestsByDay(targetDateString)

    const unitPriceTotal = summarizeUnitPrice(reportedApprovalRequests)

    const navigate = useNavigate()

    return (
        <div>
            <header
                css={css`
                    display: grid;
                    background-color: ${
                        theme.palette.intentions.cleanerBackground.main
                    };
                `}
            >
                <div
                    css={css`
                        display: grid;
                        grid-template-columns: 1fr auto 1fr;
                    `}
                >
                    <div>
                        <TextButton
                            onClick={() => {
                                navigate(-1)
                            }}
                            icon={<ArrowBackIosNewIcon />}
                            css={css`
                                padding: 8px;
                            `}
                        />
                    </div>
                    <div
                        css={css`
                            display: grid;
                            place-items: center;
                        `}
                    >
                        <Typography
                            bolder
                            css={css`
                                font-size: 20px;
                                color: ${theme.palette.intentions.text.primary};
                            `}
                        >
                            {t("作業詳細")}
                        </Typography>
                    </div>
                    <div />
                </div>

                <Typography
                    css={css`
                        padding: 8px 20px;
                    `}
                >
                    {targetDate.format("YYYY/MM/DD")}
                </Typography>
            </header>

            <div
                css={css`
                    display: grid;
                    gap: 24px;
                    padding: 16px 20px 34px 20px;
                `}
            >
                <div
                    css={css`
                        display: grid;
                        gap: 16px;
                    `}
                >
                    <div
                        css={css`
                            padding: 0 8px;
                        `}
                    >
                        <Typography
                            css={css`
                                font-size: 14px;
                            `}
                        >
                            {t("売上合計")}
                        </Typography>
                        <div
                            css={css`
                                display: flex;
                                gap: 4px;
                                align-items: center;
                            `}
                        >
                            <Payment />
                            <Typography
                                css={css`
                                    font-size: 24px;
                                `}
                            >
                                {showJpYen(unitPriceTotal)}
                            </Typography>
                        </div>
                    </div>
                    <div
                        css={css`
                            display: grid;
                            grid-auto-flow: column;
                            padding: 0 8px;
                        `}
                    >
                        <div>
                            <Typography
                                css={css`
                                    font-size: 14px;
                                `}
                            >
                                {t("単価合計")}
                            </Typography>
                            <Typography
                                bolder
                                css={css`
                                    font-size: 18px;
                                `}
                            >
                                {showJpYen(unitPriceTotal)}
                            </Typography>
                        </div>
                    </div>
                </div>

                <div
                    css={css`
                        border-bottom: 1px solid
                            ${theme.palette.intentions.cleanerGray.main};
                    `}
                />

                <CleaningPlaceList
                    reportedApprovalRequests={reportedApprovalRequests}
                />
            </div>
        </div>
    )
}

const Payment = () => {
    return <img src={PaymentIcon} alt="" />
}
